import PropTypes from 'prop-types';
import StoryItem from './storyItem';

/**
 * @memberof module:react/propTypes
 * @typedef {Object} Story
 * @prop {string} id Story id
 * @prop {string} name Story name
 * @prop {boolean} deficient True if story contains any deficient assets
 * @prop {number} index Story index
 * @prop {module:react/propTypes~StoryItem[]} items items
 */

export default PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  deficient: PropTypes.boolean,
  index: PropTypes.number,
  items: PropTypes.arrayOf(StoryItem)
});



// WEBPACK FOOTER //
// ./app/propTypes/story.js